"use strict";
var Observable_1 = require('../../Observable');
var count_1 = require('../../operator/count');
Observable_1.Observable.prototype.count = count_1.count;
//# sourceMappingURL=count.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/~/rxjs/add/operator/count.js
// module id = ../../../../rxjs/add/operator/count.js
// module chunks = 3